<template>
    <div class="apprentice-tab-buttons group-show-buttons">
        <design-2021-group-show-child-select-component
            v-if="groupTreeIn.length && groupTreeIn[0].all_children && groupTreeIn[0].all_children.length"
            :tree-in="groupTreeIn"
            :group-id="groupIn.id">
        </design-2021-group-show-child-select-component>

        <b-button
            class="btn btn-danger-icon btn-lock remove-icon-margin project-closed"
            v-b-tooltip
            v-if="closed && hasProjects"
            v-b-modal="'close-projects-modal'"
            :title="$t('group.project_closed')"
            variant="danger">
        </b-button>

        <b-button
            class="btn btn-warning-icon btn-lock remove-icon-margin project-closed"
            v-b-tooltip
            v-else-if="closing"
            v-b-modal="'close-projects-modal'"
            :title="$t('group.deadline_present')"
            variant="warning">
        </b-button>

        <div
            class="evaluate-project"
            v-if="[2, 6, 7].includes(groupIn.type_id)">
            <b-button
                class="btn-grade-check btn-assignment-check"
                v-b-modal="'evaluate-project-modal'"
                variant="primary">
                {{ $t('group.check') }}
            </b-button>
            <design-2021-project-index-evaluate-modal-component
                :group="groupIn"></design-2021-project-index-evaluate-modal-component>
        </div>

        <b-dropdown
            class="ellipsis-nav bordered-menu group-show-nav"
            variant="primary"
            right
            text="Right align"
            no-caret
            toggle-class="group-show-context-menu">
            <template #button-content>
                <i class="fas fa-fw fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item
                class="edit-group"
                v-b-modal="'edit-group-modal'">
                <i class="btn-edit"></i>{{ $t('group.edit_project') }}
            </b-dropdown-item>
            <b-dropdown-item
                class="create-child-group"
                v-if="!$authUser.isStudent()"
                @click="addSubGroup">
                <i class="btn-add"></i>{{ $t('group.new_sub_project') }}
            </b-dropdown-item>
            <b-dropdown-item
                class="lock-group"
                v-b-modal="'close-projects-modal'"
                v-if="hasProjects && !projects[0].closes_at">
                <i class="btn-lock"></i>{{ $t('group.set_paper_deadline_confirmation_title') }}
            </b-dropdown-item>
            <b-dropdown-item
                class="open-group"
                v-b-modal="'close-projects-modal'"
                v-else-if="hasProjects">
                <i class="btn-unlock"></i>{{ $t('group.adjust_deadline') }}
            </b-dropdown-item>
        </b-dropdown>

        <design-2021-edit-group-modal-component
            ref="edit-group-modal"
            :group-in="groupIn"
            :courses-in="coursesIn"
            :seasons-in="seasonsIn">
        </design-2021-edit-group-modal-component>

        <design-2021-add-sub-group-modal-component
            ref="addSubGroup"
            @sub-group-added="showSubGroup">
        </design-2021-add-sub-group-modal-component>
        <design-2021-close-projects-modal-component
            :deadline-in="deadline"
            ref="close-projects-modal"
            @remove="removeAllDeadlines($event)"
            @close="closeAll($event)">
        </design-2021-close-projects-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-show-header-buttons-component',
    props: ['groupIn', 'coursesIn', 'seasonsIn', 'groupTreeIn', 'projectsIn'],
    data() {
        return {
            group: this.groupIn,
            projects: this.projectsIn,
        };
    },
    methods: {
        showAnswerSpreadsheetModal() {
            this.$refs['answer-spreadsheet-modal'].show();
        },
        closeAll(deadline) {
            let dateTime = new Date(deadline);
            let date = `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(2, '0')}-${String(dateTime.getDate()).padStart(2, '0')}`;
            let time = `${String(dateTime.getHours()).padStart(2, '0')}:${String(dateTime.getMinutes()).padStart(2, '0')}`;
            this.alert
                .confirm(
                    this.$t('group.set_paper_deadline_confirmation_title'),
                    this.$t('group.set_paper_deadline_confirmation_body', { date, time }),
                    this.$t('common.yes'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    const data = {
                        deadline: deadline,
                    };

                    this.axios.post(this.routes.groupOpenCloseAll(this.group.id), data).then(
                        (response) => {
                            this.projects.map((project) => {
                                project.closes_at = deadline;
                                return project;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        removeAllDeadlines() {
            this.alert
                .confirm(
                    this.$t('group.delete_deadline_for_everyone_confirmation_title'),
                    this.$t('group.delete_deadline_for_everyone_confirmation_body'),
                    this.$t('common.yes'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.groupOpenCloseAll(this.group.id)).then(
                        (response) => {
                            this.projects.map((project) => {
                                project.closes_at = null;
                                return project;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        addSubGroup() {
            let group = this.groupIn;
            this.$set(group, 'group_id', this.group.id);
            this.$refs.addSubGroup.show(group);
        },

        showSubGroup(_, group) {
            window.location.href = this.routes.groupShow(group.id);
        },
    },

    computed: {
        hasProjects() {
            return this.projectsIn.length > 0;
        },
        allProjectshavetheSameDeadline() {
            if (this.projects.length) {
                let date = this.projects[0].closes_at;
                this.projects.forEach((project) => {
                    if (project.closes_at !== date) {
                        return false;
                    }
                });
            }
            return true;
        },
        deadline() {
            if (this.projects.length) {
                return this.projects[0].closes_at;
            }
            return null;
        },
        closed() {
            if (this.projects.length > 0 && !!this.projects[0].closes_at && this.allProjectshavetheSameDeadline) {
                const closeDate = new Date(this.projects[0].closes_at).getTime();
                const nowDate = new Date().getTime();

                return closeDate < nowDate;
            } else {
                return false;
            }
        },
        closing() {
            return (
                !this.closed &&
                this.projects.length > 0 &&
                !!this.projects[0].closes_at &&
                this.allProjectshavetheSameDeadline
            );
        },
    },
};
</script>

<style scoped lang="scss">
.project-closed {
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
    height: 40px;
    width: 36px;
    align-self: flex-start;
    font-size: $base-font-size;

    &:before {
        margin: 0;
        font-size: $base-font-size;
    }

    &:hover {
        cursor: default;
    }
}

.group-show-buttons ::v-deep {
    align-items: center;

    .group-show-nav {
        button.group-show-context-menu {
            color: $white !important;
            background-color: var(--primary) !important;
        }

        .create-child-group,
        .edit-group,
        .lock-group,
        .open-group {
            i {
                color: var(--primary);
            }
        }
    }
}

.group-show-buttons button {
    font-size: 1.3125rem;
}

button.btn-assignment-check {
    font-size: $default-font-size;
    line-height: 1.286;
    height: 100%;
}
</style>
